import React, { useState } from 'react';
import { Button, Col, DatePicker, Divider, Form, Input, Row, Select, Spin, Table, TimePicker, Typography } from 'antd';
import { CaretUpOutlined, CaretDownOutlined, EditOutlined, LoadingOutlined, SaveOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Option } = Select;
const { Text, Title } = Typography;


const agendaDurationFormat = "HH:mm";
const startTimeFormat = "HH:mm";

const saveButtonStates = {
    default: {
        icon: (<SaveOutlined/>),
        disabled: true
    },
    changed: {
        icon: (<SaveOutlined/>),
        disabled: false
    },
    saving: {
        icon: (<LoadingOutlined/>),
        disabled: false
    }
}

const initFields = [
    {
        name: ["stage"],
        value: "stage1"
    }
];

let formRef = React.createRef();


function SLSchedule(props) {

    const formDisplay = props.data.startGroups.length > 1 ? "initial" : "none";

    const saveButtonInit = new Array(props.data.startGroups.length).fill(saveButtonStates.default);

    const [ agendaItemAdding, setAgendaItemAdding ] = useState(false);
    const [ confSaving, setConfSaving ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ saveButton, setSaveButton ] = useState(saveButtonInit);
    const [ savedProps, setSavedProps ] = useState({});
    const [ startGroups, setStartGroups ] = useState([]);
    const [ startlist, setStartlist ] = useState({});

    if (props !== savedProps) {
        setSavedProps(props);
        setSaveButton(saveButtonInit);
        setStartGroups(props.data.startGroups);
        setStartlist(props.data.startlist);
    }

    const columns = [
        {
            title: "Startzeit",
            dataIndex: "time",
            render: text => {
                return moment.unix(text).format("HH:mm");
            }
        },
        {
            title: "Bühne",
            dataIndex: "stage",
            render: (stage, record) => {
                return (
                    <Select
                        value={stage === 2 ? "stage2" : "stage1"}
                        onChange={event => onChangeStage(record.key, event)}
                    >
                        <Option value="stage1">Bühne I</Option>
                        <Option value="stage2">Bühne II</Option>
                    </Select>
                );
            } 
        },
        {
            title: "Startgruppe",
            dataIndex: "name"
        },
        {
            title: "Teilnehmer",
            dataIndex: "countStr"
        },
        {
            title: "Plattler",
            dataIndex: "dance",
            render: (text, record) => {
                return (
                    <Input value={text} onChange={event => onChangeDance(record.key, event)}/>
                );
            }
        },
        {
            title: "Aktionen",
            key: "actions",
            render: (item, record) => {
                let thisSaveButton = saveButton[record.key] ? saveButton[record.key] : saveButtonStates.default;
                return (
                    <div style={{display: "inline-block", whiteSpace: "nowrap"}}>
                        <Button 
                            disabled={record.key === 0}
                            icon={<CaretUpOutlined/>}
                            onClick={() => onMove({up: record.key})}
                        />
                        <Button
                            disabled={record.key === props.data.startGroups.length-1}
                            icon={<CaretDownOutlined/>}
                            onClick={() => onMove({down: record.key})}
                        />
                        {
                            record.id > 50 ?
                                <Button
                                    icon={<DeleteOutlined/>}
                                    type="danger"
                                    onClick={() => { onDelete(record) }}
                                />
                            :
                                <Button
                                    disabled={thisSaveButton.disabled}
                                    icon={thisSaveButton.icon}
                                    type="primary"
                                    onClick={() => { onSave(record) }}
                                />
                        }
                    </div>
                )
            }
        }
    ];

    const changeSaveButton = (key, button) => {
        saveButton[key] = button;
        setSaveButton([ ...saveButton ]);
    };

    const finishHandler = async (values) => {
        const duration = values.duration.subtract(moment("00:00", "HH:mm")).unix();
        setLoading(true);
        setAgendaItemAdding(true);
        await props.onAddAgendaItem(
            {
                stage: values.stage === "stage2" ? 2 : 1,
                description: values.description,
                duration: duration
            }
        );
        setLoading(false);
        setAgendaItemAdding(false);    
        formRef.current.resetFields(["description", "duration"]);
        formRef.current.setFields(initFields);
    }

    const onChangeConf = (_, all) => {
        setStartlist({
            date: all.date.unix(),
            location: all.location,
            timeStage1: all.timeStage1.unix(),
            timeStage2: all.timeStage2.unix(),
            title: all.title
        });
    }

    const onChangeDance = (key, event) => {
        changeSaveButton(key, saveButtonStates.changed);
        //props.onChangeDance(key, event);
        startGroups[key].dance = event.target.value;
        setStartGroups([ ...startGroups ]);
    };

    const onChangeStage = (key, stage) => {
        changeSaveButton(key, saveButtonStates.changed);
        //props.onChangeStage(key, event);
        startGroups[key].stage = stage === "stage2" ? 2 : 1;
        setStartGroups([ ...startGroups ]);
    };

    const onDelete = async (record) => {
        setLoading(true);
        await props.onDelete({sg: record.id});
        setLoading(false);
    }

    const onMove = async cmd => {
        setLoading(true);
        await props.onMove(cmd);
        setLoading(false);
    };

    const onSave = async (record) => {
        //console.log(record);
        changeSaveButton(record.key, saveButtonStates.saving);
        await props.onSave({ sg: record.id, dance: record.dance, stage: record.stage});
        changeSaveButton(record.key, saveButtonStates.default);
    };

    const saveConf = async (values) => {
        //console.log("saveConf: ", values);
        setConfSaving(true);
        await props.onSaveConf({
            title: values.title,
            location: values.location,
            date: values.date.unix(),
            timeStage1: values.timeStage1.unix(),
            timeStage2: values.timeStage2.unix()
        });
        setConfSaving(false);
    }

    const d = new Date();
    const currentYear = d.getFullYear();

    //console.log(props.data);

    for (let i = 0; i < props.data.startGroups.length; i++) {
        let count = props.data.startGroups[i].count;
        const order = props.data.startGroups[i].order;
        let orderLength = 0;
        if (order && order.length) {
            orderLength = order.length;
        }
        let countStr = "" + orderLength;
        if (count !== orderLength) {
            countStr += " (" + count + ")";
        }
        props.data.startGroups[i].countStr = countStr;
    }
    
    return (
        <>
            <Divider style={{marginTop: 40}}>
                <Title level={3}>Veranstaltungsübersicht</Title>
            </Divider>
            <Form
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 18 }}
                fields={[
                    {
                        name: ["title"],
                        value: startlist.title
                    },
                    {
                        name: ["location"],
                        value: startlist.location
                    },
                    {
                        name: ["date"],
                        value: moment.unix(startlist.date)
                    },
                    {
                        name: ["timeStage1"],
                        value: moment.unix(startlist.timeStage1)
                    },
                    {
                        name: ["timeStage2"],
                        value: moment.unix(startlist.timeStage2)
                    }
                ]}
                onFinish={saveConf}
                onValuesChange={onChangeConf}
            >
                <Form.Item
                    label="Titel"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: "Bitte einen Titel eingeben!"
                        }
                    ]}
                >
                    <Input
                        placeholder={"Bitte einen Titel eingeben, zum Beispiel: Gaupreisplatteln " + currentYear}
                    />
                </Form.Item>
                <Form.Item
                    label="Ort"
                    name="location"
                    rules={[
                        {
                            required: true,
                            message: "Bitte einen Ort eingeben!"
                        }
                    ]}
                >
                    <Input
                        placeholder={"Bitte einen Ort eingeben"}
                    />
                </Form.Item>
                <Form.Item
                    label="Datum"
                    name="date"
                    rules={[
                        {
                            required: true,
                            message: "Bitte ein Datum eingeben!"
                        }
                    ]}
                >
                    <DatePicker
                        allowClear={false}
                        placeholder="Bitte ein Datum eingeben"
                        style={{width: 250}}
                    />
                </Form.Item>
                <Form.Item
                    label="Startzeit Bühne I"
                    name="timeStage1"
                    rules={[
                        {
                            required: true,
                            message: "Bitte eine Uhrzeit eingeben!"
                        }
                    ]}
                >
                    <TimePicker
                        allowClear={false}
                        format={startTimeFormat}
                        minuteStep={15}
                        showNow={false} 
                        placeholder="Bitte eine Uhrzeit eingeben"
                        style={{width: 250}}
                    />
                </Form.Item>
                <Form.Item
                    label="Startzeit Bühne II"
                    name="timeStage2"
                    rules={[
                        {
                            required: true,
                            message: "Bitte eine Uhrzeit eingeben!"
                        }
                    ]}
                >
                    <TimePicker
                        allowClear={false}
                        format={startTimeFormat}
                        minuteStep={15}
                        showNow={false} 
                        placeholder="Bitte eine Uhrzeit eingeben"
                        style={{width: 250}}
                    />
                </Form.Item>
                <Form.Item
                    wrapperCol={{ span: 24 }}
                    style={{ textAlign: "center" }}
                >
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SaveOutlined />}
                        loading={confSaving}
                    >
                        Veranstaltungsdaten speichern
                    </Button>
                </Form.Item>
            </Form>
            <Spin spinning={loading}>
                <Table 
                    dataSource={startGroups}
                    columns={columns}
                    style={{marginTop: 40}}
                    locale={{emptyText: "Bitte die Startliste aktualisieren..."}}
                    pagination={false}
                />
                <Row gutter={[10,10]} style={{display: formDisplay}}>
                    <Col>
                        <Text>Anderer Tagesordnungspunkt (Pause, Preisverteilung, Pokal, ...):</Text>
                    </Col>
                </Row>
                <Form
                    fields={initFields}
                    onFinish={finishHandler}
                    ref={formRef}
                    style={{display: formDisplay}}
                >
                    <Row gutter={[10,10]}>
                        <Col span={3}>
                            <Form.Item
                                name="stage"
                                defaultValue="stage1"
                            >
                                <Select>
                                    <Option value="stage1">Bühne I</Option>
                                    <Option value="stage2">Bühne II</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={14}>
                            <Form.Item
                                name="description"
                                rules={[
                                    {
                                        required: true,
                                        message: "Bitte eine Bezeichnung für den Tagesordnungspunkt eingeben!"
                                    }
                                ]}                            
                            >
                                <Input placeholder="Bezeichnung" />
                            </Form.Item>
                        </Col>
                        <Col span={3}>
                            <Form.Item
                                name="duration"
                                rules={[
                                    {
                                        required: true,
                                        message: "Bitte die Dauer festlegen!"
                                    }
                                ]}                            
                            >
                                <TimePicker
                                    allowClear={false}
                                    format={agendaDurationFormat}
                                    minuteStep={5}
                                    placeholder="Dauer"
                                    showNow={false}             
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}>
                            <Form.Item
                            >
                                <Button 
                                    type="primary"
                                    htmlType="submit"
                                    icon={<EditOutlined />}
                                    loading={agendaItemAdding}
                                >
                                    Hinzufügen
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </>
    )

}

export default SLSchedule;